import React from "react";
import style from "./progressbar.module.scss";
import toPersianNumber from "../../helpers/actions/toPersianNumber"

const Progressbar = (props) => {
    // console.log(props,"pops");
    return (
        <div className={style.bar}>
            <div className={style.progress} style={{width: (props.width ? props.width + "%" : "0%")}}>
                <div className={style.text}>
                    {props.width ? toPersianNumber(props.width + "%") : toPersianNumber("0%")}
                </div>
            </div>
        </div>
    )

}

export default Progressbar;
